import { format } from 'date-fns';

export const DISPLAY_DATE_FORMAT = 'dd/MM/yyyy';

/**
 * Interpreta fechas API preservando el día calendario (corrige bug día -1 en ISO UTC).
 */
export function parseApiDate(value) {
  if (value == null || value === '') {
    return null;
  }

  if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
    const [year, month, day] = value.split('-').map(Number);
    return new Date(year, month - 1, day);
  }

  if (typeof value === 'string' && value.includes('T')) {
    const parsed = new Date(value);
    return new Date(parsed.getUTCFullYear(), parsed.getUTCMonth(), parsed.getUTCDate());
  }

  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function formatDisplayDate(value) {
  const date = parseApiDate(value);
  if (!date) {
    return '';
  }
  return format(date, DISPLAY_DATE_FORMAT);
}

/** Serializa Date → YYYY-MM-DD sin desplazamiento UTC (Pattern B unificado). */
export function serializeDateForApi(date) {
  if (!date) {
    return null;
  }
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function buildDatePayload(fields) {
  const payload = {};
  Object.entries(fields).forEach(([key, value]) => {
    payload[key] = value instanceof Date ? serializeDateForApi(value) : value;
  });
  return payload;
}
